import { FlowPricingMode } from 'flow-schema';
import z from 'zod';

export const flowRunTaskEventSchema = z.object({
  id: z.string(),
  _sortTimestamp: z.string(),
  metricName: z.string().optional(),
  eventName: z.string().optional(),
  metricValue: z.number(),
  useCase: z.string().nullable(),
  metadata: z.record(z.string(), z.string()).optional(),
  blockId: z.string().nullable().optional(),
  blockTypeName: z.string().nullable().optional(),
  blockName: z.string().nullable().optional(),
  pricingTypes: z.array(z.enum(FlowPricingMode)).optional(),
});

export type FlowRunTaskEvent = z.infer<typeof flowRunTaskEventSchema>;

export const findAllParamsSchema = z.object({
  flowRunId: z.string(),
});

export type FlowRunTaskEventFindAllParams = z.infer<typeof findAllParamsSchema>;
